/**
 * 认证域 API 封装(登录/注册合一)。类型引用生成的 `components['schemas']`(调研§5)。
 * 端点:
 *   POST /api/v1/auth/sms/send   { phone, purpose }            → SmsSendResponse
 *   POST /api/v1/auth/login/sms  { phone, code }               → TokenPairResponse
 *   POST /api/v1/auth/register/sms { phone, code }             → TokenPairResponse
 * 沙箱验证码 = 手机号末 6 位(后端 mock,UI 不体现)。
 */
import { call, ServerError } from './client';
import type { components } from './openapi.generated';

type Schemas = components['schemas'];
export type SmsSendResponse = Schemas['SmsSendResponse'];
export type TokenPairResponse = Schemas['TokenPairResponse'];
export type SmsPurpose = 'register' | 'login' | 'bind';

/** 手机号未注册 → login 返此码,转 register(登录/注册合一)。 */
export const CODE_PHONE_NOT_REGISTERED = '010107';

export function sendSmsCode(phone: string, purpose: SmsPurpose = 'login'): Promise<SmsSendResponse> {
  return call<SmsSendResponse>({
    method: 'POST',
    url: '/api/v1/auth/sms/send',
    data: { phone, purpose } satisfies Schemas['SmsSendRequest'],
  });
}

function loginSms(phone: string, code: string): Promise<TokenPairResponse> {
  return call<TokenPairResponse>({
    method: 'POST',
    url: '/api/v1/auth/login/sms',
    data: { phone, code } satisfies Schemas['LoginSmsRequest'],
  });
}

function registerSms(phone: string, code: string): Promise<TokenPairResponse> {
  return call<TokenPairResponse>({
    method: 'POST',
    url: '/api/v1/auth/register/sms',
    data: { phone, code } satisfies Schemas['RegisterSmsRequest'],
  });
}

/**
 * 登录/注册合一:先 login;若手机号未注册(010107)自动转 register。
 * 复用既有认证签发,不新增业务规则(login.md / FR-1)。
 */
export async function loginOrRegister(phone: string, code: string): Promise<TokenPairResponse> {
  try {
    return await loginSms(phone, code);
  } catch (err) {
    if (err instanceof ServerError && err.code === CODE_PHONE_NOT_REGISTERED) {
      return registerSms(phone, code);
    }
    throw err;
  }
}
